import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import authService from '../api-authorization/AuthorizeService'
import LinkButton from '../LinkButton';
import { Thunderbolt, Tree } from 'react-bootstrap-icons';
import ProductDetail from './ProductDetail';
import ProductLocations from './ProductLocations'

export class ProductEnquiry extends Component {
    static displayName = ProductEnquiry.name;
    constructor(props) {
        super(props);
        this.state = {
            productDetail: [],
            loading: false,
            alertMessage: "",
            inputProductBarcode: "",
            selectedProduct: null,
            currentIndex: 0,
            toggleProductLocation: false
        };
        this.history = props.history;
    }

    componentDidMount() {
        this.refs.barcodeScanInput.focus();
    }
    goto(page) {
        this.history.push(page);
    }

    render() {
        let loadingProgress = this.state.loading ? <p><em>Loading...</em></p> : <p></p>;
        let productDetailsContent = this.state.productDetail.length == 0 ? <p><em></em></p> : <ProductDetail productDetail={this.state.selectedProduct}></ProductDetail>;
        const handlebarcodeKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.loadProductDetail();
            }
        };
        return <div className="container" >
            <h3>Product Enquiry</h3>
            {!this.state.toggleProductLocation && <Container>
                <Row>
                    <Col>
                        <label>Enter Product Barcode:</label>
                        <input ref="barcodeScanInput" className="form-control" placeholder="Enter Product Barcode"
                            value={this.state.inputProductBarcode}
                            onChange={(e) => {
                                this.setState({ inputProductBarcode: e.target.value });
                            }} onKeyPress={handlebarcodeKeyPress} readOnly={this.state.loading}>
                        </input>
                    </Col>
                </Row>
                <Row>
                    <Col >
                        <button type="button" className="btn btn-success col-12 mb-2 mt-1" onClick={() => { this.loadProductDetail(); }}>Search</button>
                    </Col>
                </Row>
                <Row>
                    <Col>{loadingProgress}</Col>
                </Row>
                <Row>
                    <Col>
                        {this.state.productDetail.length == 0 ? <em></em> : <em>{this.state.productDetail.length} product(s) found.</em>}
                        {this.state.productDetail.length == 0 ? <p><em></em></p> : <ProductDetail key={this.state.productDetail[this.state.currentIndex].PRODUCT_ID} productDetail={this.state.productDetail[this.state.currentIndex]}></ProductDetail>}
                    </Col>
                </Row>
                <Row>
                    <Col>{this.state.productDetail.length > 1 && this.state.currentIndex > 0 && <Button variant="info" className="mt-1" onClick={() => { this.previousProduct() }}>Previous</Button>}</Col>
                    <Col>{this.state.productDetail.length > 1 && <Button variant="info" className="mt-1" onClick={() => { this.nextProduct() }}>Next</Button>}</Col>
                    <Col>{this.state.productDetail.length > 0 && <Button variant="primary" className="mt-1 float-right" onClick={() => { this.setState({ toggleProductLocation: true }) }}>Location</Button>}</Col>
                </Row>
            </Container>}
            {this.state.toggleProductLocation && <Container>
                <Row>
                    <Col>
                        <ProductLocations productId={this.state.productDetail[this.state.currentIndex].PRODUCT_ID }></ProductLocations>
                    </Col>
                </Row>
                <Row>
                    <Col><Button variant="secondary" className="col-12" onClick={() => { this.setState({ toggleProductLocation: false }) }}> back</Button></Col>
                </Row>

            </Container>}
        </div>
    }

    nextProduct() {
        if (this.state.currentIndex < this.state.productDetail.length - 1) {
            let nextIndex = this.state.currentIndex + 1
            this.setState({ currentIndex: nextIndex });
        }
    }
    previousProduct() {
        if (this.state.currentIndex > 0) {
            let prevIndex = this.state.currentIndex - 1
            this.setState({ currentIndex: prevIndex });
        }
    }

    async loadProductDetail() {
        this.setState({ productDetail: [] });
        this.setState({ loading: true, currentIndex: 0 });
        fetch(`api/Enquiry/GetProductDetail?barcode=${this.state.inputProductBarcode}`)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Cannot load Inventories in Transfer. " + errorText });
                }
                else {
                    this.setState({ productDetail: data, loading: false, selectedProduct: data[this.state.currentIndex] });

                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }


}
export default ProductEnquiry;
